import {KTSVG} from '../../../_metronic/helpers'
import {FC, useEffect, useState, forwardRef, useImperativeHandle, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import {useAllexpensetypes, useAddexpenses, useAddexpensetype} from '../../contextProviders/Atomqueryprovider'
import { useSelectStyles } from '../../helpers/useSelectStyles'
import CreatableSelect from 'react-select/creatable'
import EditableDiv from '../../helpers/components/EditableDiv'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'

type Props = {
  show: boolean
  handleClose: () => void
  sumexpenserefetch?:  () => void
  sumprofitorlossrefetch?:  () => void
  ref: any
 
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY

const initialValues = {
  expense_name: '',
  description: '',
  
}


const productSchema = Yup.object().shape({
  expense_name: Yup.string().required('A unique expense name is required')
  .notOneOf(
    [null, ''],
    'A unique expense name is required'
  ),
  description: Yup.string().required('A description is required'),

})
export const Addexpensetype: FC<Props> = forwardRef((props, ref) => {
 

  const [loading, setLoading] = useState(false)
  const [newSetquantity, setNewSetquantity] = useState(false)
  const [newSetprice, setNewSetprice] = useState<number>(0)
  const [expense_type_id, setExpense_type_id] = useState<number>(0)
  const [expensetypeadded, setExpensetypeadded] = useState<any>([])
  const [submittingready, setSubmittingready] = useState<boolean>(false)
  
  const {
    isLoading: expensetypeloading,
    isSuccess: expensetypesuccess,
    data: expensetypedata,
   
  } = useAllexpensetypes()




  const {
    mutateAsync: addexpensetypemutateAsync
  } =  useAddexpensetype(expensetypeadded)


  const formik = useFormik({
    initialValues,
    validationSchema: productSchema,
    validateOnBlur: true,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
  
      setLoading(true)

      setExpensetypeadded([{
        expense_name: values.expense_name,
        description: values.description
        
      }])

      setSubmittingready(true)
    },
  })

  useEffect(() => {
    if (submittingready && expensetypeadded) {

      
      addexpensetypemutateAsync(expensetypeadded, {
        onSuccess: () => {
          setLoading(false)
          formik.resetForm({})
          formik.setSubmitting(false)
          setExpensetypeadded({})
          
          setSubmittingready(false)
          props.handleClose()
        },
        onError(error, variables, context) {
          formik.setStatus('The expense type details are incorrect')
          formik.setSubmitting(false)
          setLoading(false)
        },
      })
    }
  }, [submittingready])

 


  useImperativeHandle(ref, () => ({
    Resetmodalexpensetypevalues() {
     

      setNewSetprice(0)

      setNewSetquantity(false)
      setExpense_type_id(0)
    },
  }))


  

  let options = expensetypesuccess && expensetypedata?.data.map((val: any, index: any) => {
    return {
      value: val.expense_type_id,
      label: val.expense_name,
    }
  })

  const expenseNameExists = (expenseName: any, options: any) => {
    return options.some((option: any) => option.label.toLowerCase() === expenseName.toLowerCase());
  }
 
  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Add Expense Type</h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form
           noValidate
           id='kt_expensetype_adding_form'
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          onSubmit={formik.handleSubmit}>
                   
            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Expense Type</label>
              {/* end::Label */}

              <CreatableSelect
                options={options}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={expensetypeloading}
                isSearchable={true}
                placeholder={"Create New Expense Type ...."}
                onChange={(selectedOption: any) =>{
                  if(!expenseNameExists(selectedOption.label, options))
                  {
                  formik.setFieldValue('expense_name', selectedOption.label)
                  }
                  else{

                    formik.setFieldValue('expense_name', null)
                  }

                 } }
              />
              {formik.touched.expense_name && formik.errors.expense_name && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.expense_name}</span>
                      </div>
                    </div>
                  )}
            </div>
            {/* end::Input group */}

              {/* begin::Input group */}
             <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Expense Description</label>
              {/* end::Label */}

              <div className='d-flex flex-column flex-grow-1'>
                <div className='d-flex flex-wrap'>
                  <div className='col-12'>
                    
                   <EditableDiv 
                       placeholder='Add your description here ...'
                       initialContent=''
                       onChange={(x: any)=> formik.setFieldValue('description', x)}
                       className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.description && formik.errors.description,
                      },
                      {
                        'is-valid': formik.touched.description && !formik.errors.description,
                      }
                    )}
                        /> 
                  

                    {formik.touched.description && formik.errors.description && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.description}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* end::Input group */}



          
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_expensetype_adding_form'
            className='btn btn-info'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            {!loading && <span className='indicator-label'>Add New Expense Type</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
})
